import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const Carts = () => {
  const { t } = useTranslation();

  return (
    <div className="container-fluid p-2 bg-primary text-white">
        <div className="container text-center">
            <div className="row">
                <div style={{ overflow: "hidden", width: "100%" }}>
                    <motion.h1
                        initial={{ x: "-100%" }}
                        animate={{ x: "100%" }}
                        transition={{
                        repeat: Infinity,
                        repeatType: "loop",
                        duration: 8,
                        ease: "linear",
                        }}
                        style={{
                        whiteSpace: "nowrap",
                        fontSize: "2rem",
                        fontWeight: "bold",
                        }}
                    >
                        🚗 {t("cars.title")}
                    </motion.h1>
                </div>
            </div>
        </div>
    </div>
  );
};
